import Axios from "axios";
import { ApiBaseUrl, CartableBaseUrl } from "../config/config";
import { GetStatusResponse } from "../models/basicInformation.model";
import {
  CartableNotification,
  DoActionRequest,
  DoActionResponse,
  GetAppRegistrationItemsResponse,
  GetCartableActionsRequest,
  GetCartableActionsResponse,
  GetCartablesRequest,
  GetCartablesResponse,
  GetCoreInformationResponse,
  GetSaleItemsRequest,
  GetSaleItemsResponse,
  GetSupplierInformationRequest,
  GetSupplierInformationResponse,
  GetSupplierRequirementItemsRequest,
  GetSupplierRequirementItemsResponse,
  GetSupplierSettlementItemsRequest,
  GetSupplierSettlementItemsResponse,
  GetWorkflowTypesResponse,
  ReferenceKey,
} from "../models/cartable.model";
import { ApiResultModel } from "../models/common.model";

export const GetCartableNotification = (): Promise<CartableNotification> => {
  return Axios.post<ApiResultModel<CartableNotification>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCartableNotification"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetWorkflowTypes = (): Promise<GetWorkflowTypesResponse[]> => {
  return Axios.post<ApiResultModel<GetWorkflowTypesResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetWorkflowTypes"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetCartables = (
  request: GetCartablesRequest
): Promise<GetCartablesResponse[]> => {
  return Axios.post<ApiResultModel<GetCartablesResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCartables",
    request
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierSettlementItems = (
  request: GetSupplierSettlementItemsRequest
): Promise<ApiResultModel<GetSupplierSettlementItemsResponse[]>> => {
  return Axios.post<ApiResultModel<GetSupplierSettlementItemsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetSupplierSettlementItems",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetAppRegistrationItems = (
  request: GetSupplierSettlementItemsRequest
): Promise<ApiResultModel<GetSupplierSettlementItemsResponse[]>> => {
  return Axios.post<ApiResultModel<GetSupplierSettlementItemsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetAppRegistrationItems",
    request
  ).then((result) => {
    return result.data;
  });
};
export const GetRegistrationItems = (
  request: GetSupplierSettlementItemsRequest
): Promise<ApiResultModel<GetAppRegistrationItemsResponse[]>> => {
  return Axios.post<ApiResultModel<GetAppRegistrationItemsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetRegistrationItems",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetRegisterBySupplierItems = (
  request: GetSupplierSettlementItemsRequest
): Promise<ApiResultModel<GetSupplierSettlementItemsResponse[]>> => {
  return Axios.post<ApiResultModel<GetSupplierSettlementItemsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetRegisterBySupplierItems",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetCartableActions = async (
  data: GetCartableActionsRequest
): Promise<GetCartableActionsResponse[]> => {
  return await Axios.post<ApiResultModel<GetCartableActionsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCartableActions",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DoAction = (
  data: DoActionRequest
): Promise<ApiResultModel<DoActionResponse>> => {
  return Axios.post<ApiResultModel<DoActionResponse>>(
    ApiBaseUrl + CartableBaseUrl + "/DoAction",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCoreInformation = async (
  data: ReferenceKey
): Promise<ApiResultModel<GetCoreInformationResponse>> => {
  return await Axios.post<ApiResultModel<GetCoreInformationResponse>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCoreInformation",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetAppInformation = async (
  data: ReferenceKey
): Promise<ApiResultModel<GetCoreInformationResponse>> => {
  return await Axios.post<ApiResultModel<GetCoreInformationResponse>>(
    ApiBaseUrl + CartableBaseUrl + "/GetCoreInformation",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSupplierRequirementItems = (
  request: GetSupplierRequirementItemsRequest
): Promise<ApiResultModel<GetSupplierRequirementItemsResponse[]>> => {
  return Axios.post<ApiResultModel<GetSupplierRequirementItemsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + CartableBaseUrl + "/GetSupplierRequirementItems",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetSupplierInformation = async (
  data: GetSupplierInformationRequest
): Promise<GetSupplierInformationResponse> => {
  return await Axios.post<ApiResultModel<GetSupplierInformationResponse>>(
    // SERVIES_URL
    ApiBaseUrl + CartableBaseUrl + "/GetSupplierInformation",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanTemplates = async (): Promise<GetStatusResponse[]> => {
  return await Axios.post<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetLoanTemplates"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetOrganizations = async (): Promise<GetStatusResponse[]> => {
  return await Axios.post<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetOrganizations"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetSaleItems = async (
  data: GetSaleItemsRequest
): Promise<ApiResultModel<GetSaleItemsResponse[]>> => {
  return await Axios.post<ApiResultModel<GetSaleItemsResponse[]>>(
    ApiBaseUrl + CartableBaseUrl + "/GetSaleItems",
    data
  ).then((result) => {
    return result.data;
  });
};
